import { render, staticRenderFns } from "./SearchLocation.vue?vue&type=template&id=0bd2825c"
import script from "./SearchLocation.vue?vue&type=script&lang=js"
export * from "./SearchLocation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports